import React, { useState } from 'react';
import './Contact.css';
import axios from 'axios'; // Import Axios
import contactImage from '../assets/images/contact.jpg';

function Contact() {
    // State for the form fields
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    // Handle changes in form fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSubmitted(false);

        try {
            // Send the form data to the PHP backend
            const response = await axios.post('https://unpager.com/backend/submit_form.php', formData);

            // Check if the submission was successful
            if (response.status === 200) {
                setSubmitted(true); // Success, show a success message
                console.log('Form submitted:', formData);
                alert('Your message has been sent!');
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            console.error('Error response:', error.response);

            if (error.response) {
                setErrorMessage(`Oops! There was an error submitting the form. Error Details: ${error.response.status} - ${error.response.statusText}. Please reach us at 'contact@dhank.com'`);
                alert("Error submitting form");
            } else {
                setErrorMessage('Sorry! There was an error submitting the form. Please reach us at \'contact@dhank.com\'');
                alert("Error submitting form");
            }
        }

        

    };

    return (
        <div className="contact">
            <h1>Reach out to us</h1>
            <img src={contactImage} alt="Contact Us" />
            <p>
                Get in touch with us to start your next web project.
            </p>
            <br />
            <p>
                We'd love to hear from you. Send us a message below or email us at contact@unpager.com.
            </p>

            {/* Contact Form */}
            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />
                </div>
                <button type="submit">Send Message</button>
            </form>
            {errorMessage && <p className="error">{errorMessage}</p>}
        </div>
    );
}

export default Contact;
